import { DoubleRangeSlider } from '@eti/components';
import type { FilterType } from '@eti/schema-types';
import { roundDown, roundUp } from './utils/searchFilters';
import type { Filters } from './v3/MobileFilters';
import Filter from './Filter';

const isSelected = (selectedValues: number[], minValue: number, maxValue: number) => {
  const [selectedMin, selectedMax] = selectedValues;
  return selectedMin !== minValue || selectedMax !== maxValue;
};

type RangeSliderFilterProps = {
  className: string;
  formatDisplayedValue: (value: any) => any;
  isInitiallyExpanded: boolean;
  isToggleable: boolean;
  label: string;
  maxValue: number;
  minValue: number;
  name: string;
  onFilter: (filter: any) => void;
  getPriceCurrencySRText: (value: string) => string;
  selectedValues: Filters[typeof FilterType.Price];
  step?: number;
  minValueLabel?: string;
  maxValueLabel?: string;
};

const RangeSliderFilter = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  formatDisplayedValue = (value) => value,
  label,
  maxValue,
  minValue,
  name,
  onFilter,
  getPriceCurrencySRText,
  selectedValues,
  step = 1,
  minValueLabel,
  maxValueLabel,
}: RangeSliderFilterProps) => {
  const roundedMin = roundDown(minValue, step);
  const roundedMax = roundUp(maxValue, step);

  const handleReset = () => {
    onFilter({ [name]: null });
  };

  const handleChange = (values: number[]) => {
    if (!isSelected(values, roundedMin, roundedMax)) {
      handleReset();
    } else {
      const [min, max] = values;
      onFilter({ [name]: { min, max } });
    }
  };

  const handleValues = selectedValues
    ? [selectedValues.min, selectedValues.max]
    : [roundedMin, roundedMax];

  return (
    <Filter
      className={className}
      isInitiallyExpanded={isInitiallyExpanded}
      isSelected={isSelected(handleValues, roundedMin, roundedMax)}
      isToggleable={isToggleable}
      label={label}
      name={name}
      onReset={handleReset}
    >
      <DoubleRangeSlider
        formatDisplayedValue={formatDisplayedValue}
        getPriceCurrencySRText={getPriceCurrencySRText}
        handleValues={handleValues}
        handleValuesChange={handleChange}
        maxValue={roundedMax}
        maxValueLabel={maxValueLabel}
        minValue={roundedMin}
        minValueLabel={minValueLabel}
      />
    </Filter>
  );
};

export default RangeSliderFilter;
